import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./search-family.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./search-family.component.scss?ngResource";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ApplicationSearchService } from "../../../../shared/application-search.service";
import { ApplicationSearchConstants } from "../../../application-search-constants";
import { AflaModuleStrategyService } from "../../../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../../../app-controller.service";
let SearchFamilyComponent = class SearchFamilyComponent {
    applicationSearchService;
    aflaModuleStrategyService;
    appController;
    familyNameLabel = ApplicationSearchConstants.FORM_CONTROLS.contactNameLabel;
    familySurnameLabel = ApplicationSearchConstants.FORM_CONTROLS.contactSurnameLabel;
    familyNameFormControl = ApplicationSearchConstants.FORM_CONTROLS.nameFormControl;
    familySurnameFormControl = ApplicationSearchConstants.FORM_CONTROLS.surnameFormControl;
    searchText = ApplicationSearchConstants.FORM_CONTROLS.searchText;
    familyForm;
    applicationSearchCallback;
    constructor(applicationSearchService, aflaModuleStrategyService, appController) {
        this.applicationSearchService = applicationSearchService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.appController = appController;
    }
    ngOnInit() {
        this.setUpForm();
    }
    searchApplication($event) {
        const parlourName = this.familyForm.get(this.familyNameFormControl).value;
        const parlourSurname = this.familyForm.get(this.familySurnameFormControl).value;
        this.applicationSearchCallback(this.applicationSearchService.searchByFamilyMember(parlourName, parlourSurname, this.aflaModuleStrategyService, Number(this.appController.selectedModuleID)));
    }
    setUpForm() {
        this.familyForm = new FormGroup({
            nameFormControl: new FormControl(""),
            surnameFormControl: new FormControl("")
        });
    }
    static ctorParameters = () => [
        { type: ApplicationSearchService },
        { type: AflaModuleStrategyService },
        { type: AppControllerService }
    ];
};
SearchFamilyComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-search-family",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], SearchFamilyComponent);
export { SearchFamilyComponent };
